// extracted by mini-css-extract-plugin
module.exports = {"paper":"a3-qr-40x20-whitout-text_paper__6-m6L","page":"a3-qr-40x20-whitout-text_page__15NuL","label":"a3-qr-40x20-whitout-text_label__3AUxF"};